import { openChannelList, selectChannel } from 'actions/channels'
import classnames from 'classnames'
import Focusable from 'components/focusable'
import styles from 'components/styles/main-menu.css'
import {
  VIEW_MODE_CHANNEL_BANNER,
  VIEW_MODE_CHANNEL_GUIDE,
  VIEW_MODE_CHANNEL_LIST
} from 'constants/channels'
import defaultLogoExtended from 'img/main-menu-logo-extended.png'
import defaultLogo from 'img/main-menu-logo.png'
import { rememberChannelId, requestChannelViewMode } from 'libs/channels'
import { Component } from 'preact'
import { route } from 'preact-router'
import { connect } from 'react-redux'
import {
  getAllowYouTube,
  getMainMenuItems,
  isLoggedIn,
  selectCheckoutModuleEnabled,
  selectForceLogin
} from 'selectors/app'
import { isReady as channelsAreReady } from '../selectors/channels'

class MainMenu extends Component {
  constructor(props) {
    super(props)
    this.items = this.filterItems(
      props.items.length > 0 ? props.items : this.getDefaultItems()
    )
    this.scroller = null
    const currentPosition = this.items.findIndex(
      item =>
        item.actionTarget === this.props.selectedItem ||
        (item.actionTarget === 'login' &&
          this.props.selectedItem === 'register')
    )
    const focusedPosition = currentPosition > 0 ? currentPosition : 0
    const [start, end] = this.getSlice(focusedPosition)
    this.state = {
      focusedPosition: focusedPosition,
      arrowUp: start > 0,
      arrowDown: end < this.items.length
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.items && nextProps.items.length > 0) {
      this.items = this.filterItems(nextProps.items)
    }
  }

  filterItems = items => {
    const knownTargets = [
      'home',
      'guide',
      'channel',
      'channels',
      'dvr',
      'video_library',
      'search',
      'settings',
      'support',
      'video_library_category',
      'external_url',
      'external_url_iframe',
      'html5_games',
      'html5_apps',
      'radios'
    ]
    if (this.props.isLoggedIn) {
      knownTargets.push('account')
    } else {
      knownTargets.push('login')
    }
    if (this.props.checkoutModule) {
      knownTargets.push('checkout')
    }
    if (this.props.allowYouTube) {
      knownTargets.push('youtube')
    }
    return items.filter(
      (item, index) => knownTargets.indexOf(item.actionTarget) !== -1
    )
  }

  onArrowUp = pos => () => {
    let prevPos = pos - 1
    if (prevPos < 0) {
      prevPos = 0
    }
    this.setFocusedPosition(prevPos)
  }

  onArrowDown = pos => () => {
    let nextPos = pos + 1
    if (nextPos >= this.items.length) {
      nextPos = this.items.length - 1
    }
    this.setFocusedPosition(nextPos)
  }

  onArrowRight = () => {
    this.props.close()
  }

  onEnter = pos => () => {
    if (this.props.forceLogin && !this.props.isLoggedIn) {
      this.props.close()
      return
    }
    const item = this.items[pos]
    switch (item.actionTarget) {
      case 'guide':
        if (this.props.selectedItem === 'guide') {
          this.props.close()
        } else {
          if (this.props.channelsAreReady) {
            this.props.selectChannel(-1, VIEW_MODE_CHANNEL_GUIDE)
          } else {
            requestChannelViewMode(VIEW_MODE_CHANNEL_GUIDE)
          }
          route(`${__webpack_public_path__ || '/'}live`)
        }
        break
      case 'channels':
        if (this.props.selectedItem === 'guide') {
          this.props.close()
          this.props.openChannelList()
        } else {
          if (this.props.channelsAreReady) {
            route(`${__webpack_public_path__ || '/'}live`)
            setTimeout(() => {
              this.props.openChannelList()
            }, 50)
          } else {
            requestChannelViewMode(VIEW_MODE_CHANNEL_LIST)
            route(`${__webpack_public_path__ || '/'}live`)
          }
        }
        break
      case 'channel':
        if (item.actionId > 0) {
          if (this.props.channelsAreReady) {
            this.props.selectChannel(+item.actionId, VIEW_MODE_CHANNEL_BANNER)
          } else {
            rememberChannelId(+item.actionId)
            requestChannelViewMode(VIEW_MODE_CHANNEL_BANNER)
            route(`${__webpack_public_path__ || '/'}live`)
          }
        }
        break
      case 'login':
        if (this.props.selectedItem === 'login') {
          this.props.close()
        } else {
          route(`${__webpack_public_path__ || '/'}auth/login`)
        }
        break
      case 'account':
        if (this.props.selectedItem === 'account') {
          this.props.close()
        } else {
          route(`${__webpack_public_path__ || '/'}account`)
        }
        break
      case 'dvr':
        this.props.close()
        route(`${__webpack_public_path__ || '/'}dvr`)
        break
      case 'video_library':
        this.props.close()
        route(`${__webpack_public_path__ || '/'}video-library`)
        break
      case 'video_library_category':
        this.props.close()
        route(
          `${__webpack_public_path__ || '/'}video-category/${item.actionId}`
        )
        break
      case 'checkout':
        if (this.props.selectedItem === 'checkout') {
          this.props.close()
        } else {
          route(`${__webpack_public_path__ || '/'}checkout`)
        }
        break
      case 'support':
        if (this.props.selectedItem === 'support') {
          this.props.close()
        } else {
          route(`${__webpack_public_path__ || '/'}support`)
        }
        break
      case 'search':
        if (this.props.selectedItem === 'search') {
          this.props.close()
        } else {
          route(`${__webpack_public_path__ || '/'}search`)
        }
        break
      case 'home':
        if (this.props.selectedItem === 'channel-previews') {
          this.props.close()
        } else {
          route(`${__webpack_public_path__ || '/'}`)
        }
        break
      case 'youtube':
        if (this.props.selectedItem === 'youtube') {
          this.props.close()
        } else {
          route(`${__webpack_public_path__ || '/'}youtube`)
        }
        break
      case 'settings':
        if (this.props.selectedItem === 'settings') {
          this.props.close()
        } else {
          route(`${__webpack_public_path__ || '/'}settings`)
        }
        break
      case 'external_url':
        window.location.href = item.actionUrl
        break
      case 'external_url_iframe':
        this.props.close()
        route(`${__webpack_public_path__ || '/'}external/${item.id}`)
        break
      case 'html5_games':
        if (this.props.selectedItem === 'games') {
          this.props.close()
        } else {
          route(`${__webpack_public_path__ || '/'}games`)
        }
        break
      case 'html5_apps':
        if (this.props.selectedItem === 'apps') {
          this.props.close()
        } else {
          route(`${__webpack_public_path__ || '/'}apps`)
        }
        break
      case 'radios':
        this.props.close()
        route(`${__webpack_public_path__ || '/'}radios`)
        break
      default:
    }
  }

  getDefaultItems = () => [
    {
      id: 10,
      name: 'Home',
      icon:
        'https://www.tikilive.com/public/files/applications/icons/main_menu_home.png',
      actionTarget: 'home'
    },
    {
      id: 20,
      name: 'Login',
      icon:
        'https://www.tikilive.com/public/files/applications/icons/main_menu_login.png',
      actionTarget: 'login'
    },
    {
      id: 30,
      name: 'My Account',
      icon:
        'https://www.tikilive.com/public/files/applications/icons/main_menu_account.png',
      actionTarget: 'account'
    },
    {
      id: 40,
      name: 'Guide',
      icon:
        'https://www.tikilive.com/public/files/applications/icons/main_menu_guide.png',
      actionTarget: 'guide'
    },
    {
      id: 50,
      name: 'Channels',
      icon:
        'https://www.tikilive.com/public/files/applications/icons/main_menu_channels.png',
      actionTarget: 'channels'
    },
    {
      id: 60,
      name: 'On Demand',
      icon:
        'https://www.tikilive.com/public/files/applications/icons/main_menu_ondemand.png',
      actionTarget: 'video_library'
    },
    {
      id: 70,
      name: 'DVR',
      icon:
        'https://www.tikilive.com/public/files/applications/icons/main_menu_scenerecall.png',
      actionTarget: 'dvr'
    },
    {
      id: 80,
      name: 'Pick Package',
      icon:
        'https://www.tikilive.com/public/files/applications/icons/main_menu_shop.png',
      actionTarget: 'checkout'
    },
    {
      id: 90,
      name: 'Search',
      icon:
        'https://www.tikilive.com/public/files/applications/icons/main_menu_search.png',
      actionTarget: 'search'
    },
    {
      id: 100,
      name: 'Settings',
      icon:
        'https://www.tikilive.com/public/files/applications/icons/main_menu_settings.png',
      actionTarget: 'settings'
    },
    {
      id: 110,
      name: 'YouTube',
      icon:
        'https://www.tikilive.com/public/files/applications/icons/main_menu_channels.png',
      actionTarget: 'youtube'
    },
    {
      id: 120,
      name: 'Support',
      icon:
        'http://www.tikilive.com/public/files/applications/icons/main_menu_support.png',
      actionTarget: 'support'
    }
  ]

  getSlice = focusedPosition => {
    let start = focusedPosition < 8 ? 0 : focusedPosition - 8
    if (this.items.length > 8 && start > this.items.length - 8) {
      start = this.items.length - 8
    }
    let end = start + 9
    if (end > this.items.length) {
      end = this.items.length
    }
    return [start, end]
  }

  setFocusedPosition = focusedPosition => {
    const [start, end] = this.getSlice(focusedPosition)
    this.setState({
      focusedPosition: focusedPosition,
      arrowUp: start > 0,
      arrowDown: end < this.items.length
    })
  }

  render() {
    const shouldFocus =
      this.props.shouldFocus === true ||
      typeof this.props.shouldFocus === 'undefined'
    const selectedItem = this.props.items.find(
      item =>
        item.actionTarget === this.props.selectedItem ||
        (item.actionTarget === 'login' &&
          this.props.selectedItem === 'register') ||
        (item.actionTarget === 'external_url_iframe' &&
          this.props.selectedItem === `external-url-${item.id}`) ||
        (item.actionTarget === 'html5_games' &&
          this.props.selectedItem === 'games') ||
        (item.actionTarget === 'html5_apps' &&
          this.props.selectedItem === 'apps')
    )
    const logo =
      typeof window.TKL_LOGO !== 'undefined' ? window.TKL_LOGO : defaultLogo
    const logoExtended =
      typeof window.TKL_LOGO_EXTENDED !== 'undefined'
        ? window.TKL_LOGO_EXTENDED
        : defaultLogoExtended
    const [start, end] = this.getSlice(this.state.focusedPosition)
    return (
      <div
        class={classnames(styles.mainMenu, {
          [styles.mainMenuOpen]: this.props.isOpen
        })}>
        <div class={styles.mainMenuComponent}>
          <div
            class={styles.mainMenuLogo}
            style={{
              backgroundImage: `url(${this.props.isOpen ? logoExtended : logo})`
            }}
          />
          <div
            class={classnames(styles.arrow, {
              [styles.visible]: this.state.arrowUp
            })}>
            <span class={styles.arrowUp}></span>
          </div>
          {this.items.slice(start, end).map((item, i) => (
            <Focusable
              class={classnames(styles.mainMenuItem, {
                [styles.selected]:
                  selectedItem &&
                  selectedItem.actionTarget === item.actionTarget
              })}
              isFocused={
                this.props.isOpen &&
                shouldFocus &&
                i + start === this.state.focusedPosition
              }
              onArrowUp={this.onArrowUp(i + start)}
              onArrowDown={this.onArrowDown(i + start)}
              onArrowLeft={null}
              onArrowRight={this.onArrowRight}
              onEnter={this.onEnter(i + start)}
              onBack={this.props.close}>
              <div
                class={styles.mainMenuIcon}
                style={{ backgroundImage: `url(${item.icon})` }}>
                {this.props.isOpen ? <span>{item.name}</span> : ''}
              </div>
            </Focusable>
          ))}
          <div
            class={classnames(styles.arrow, {
              [styles.visible]: this.state.arrowDown
            })}>
            <span class={styles.arrowDown}></span>
          </div>
        </div>
        <div class={styles.mainMenuShadows}></div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  items: getMainMenuItems(state),
  isLoggedIn: isLoggedIn(state),
  channelsAreReady: channelsAreReady(state),
  allowYouTube: getAllowYouTube(state),
  checkoutModule: selectCheckoutModuleEnabled(state),
  forceLogin: selectForceLogin(state)
})

const mapDispatchToProps = {
  selectChannel,
  openChannelList
}

export default connect(mapStateToProps, mapDispatchToProps)(MainMenu)
